import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Switches favicon + title based on the active route group.
// Default = TotalKlick. Routes under /totalpl (app PrintLab interno) → TotalPL branding.
// Login/signup/superadmin sono unificati ecosistema → TotalKlick.
const TOTALPL_PREFIXES = [
    "/totalpl", "/dashboard", "/commesse", "/clienti", "/inbox",
    "/telegram", "/landing", "/configurazione",
    "/t/", "/track",
];

const APP_TITLES = {
    design: "Design & Stampa · TotalKlick",
};

function setFavicon(href, type = "image/svg+xml") {
    let link = document.querySelector("link[rel='icon'][type='image/svg+xml']");
    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        link.type = type;
        document.head.appendChild(link);
    }
    link.href = href;
}

export default function RouteMeta() {
    const { pathname } = useLocation();
    useEffect(() => {
        const isTotalPL = TOTALPL_PREFIXES.some(p => pathname === p || pathname.startsWith(p + "/") || pathname === p);
        const appMatch = pathname.match(/^\/app\/(\w+)/);
        if (isTotalPL) {
            document.title = "TotalPL · PrintLab";
            setFavicon("/icon-totalpl.png", "image/png");
        } else if (appMatch && APP_TITLES[appMatch[1]]) {
            document.title = APP_TITLES[appMatch[1]];
            setFavicon("/brand/tk/favicon.svg");
        } else {
            document.title = "TotalKlick · Digital Services";
            setFavicon("/brand/tk/favicon.svg");
        }
    }, [pathname]);
    return null;
}
